import { render } from "./GroupSchedule.vue?vue&type=template&id=1f917ba4&scoped=true"
import script from "./GroupSchedule.vue?vue&type=script&lang=js"
export * from "./GroupSchedule.vue?vue&type=script&lang=js"

import "./GroupSchedule.vue?vue&type=style&index=0&id=1f917ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f917ba4"]])

export default __exports__